import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { PlayerImg_anyPlayer } from './__generated__/index.graphql';

const Root = styled.div`
  position: relative;
  height: 359px;
  width: 311px;
  padding-top: calc(6 * var(--unit));
`;
const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 33%;
`;

const Player = styled.img`
  clip-path: path(
    'M 50.837608 -0.043213 L 0 41 C 0 41 0.130972 236.424927 0 238 C -0.421635 243.070618 4.640633 248.376099 8.999999 251 C 12.90026 253.347565 147 310 156 310 C 164 310 262.052368 266.462646 300 251 C 308.037506 243.440903 310 238 310 238 L 311 40 L 264.271301 0.143188 Z'
  );
  width: 100%;
  aspect-ratio: 1;
`;

type Props = {
  player: PlayerImg_anyPlayer;
  overlay?: string;
};

export const PlayerImg = ({ player: { recoAvatarUrl }, overlay }: Props) => {
  return (
    <Root>
      <Player src={recoAvatarUrl} alt="" />
      <Overlay
        style={{
          background:
            overlay ||
            'linear-gradient(180deg, rgba(33, 33, 33, 0) 0%, #212121 87.88%)',
        }}
      />
    </Root>
  );
};

PlayerImg.fragments = {
  anyPlayer: gql`
    fragment PlayerImg_anyPlayer on AnyPlayerInterface {
      slug
      recoAvatarUrl: squaredPictureUrl
    }
  ` as TypedDocumentNode<PlayerImg_anyPlayer>,
};
